import { getFirstGameDate } from '@wt/utilities/siteMode';
import dayjs from 'dayjs';

export default function getPuzzleNumber(date: string): number {
  const regEx = /^\d{4}-\d{2}-\d{2}$/;
  if (regEx.test(date)) {
    return Number(dayjs(date).diff(dayjs(getFirstGameDate()), 'day') + 1);
  } else {
    return 0;
  }
}
